/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

export enum FormulaTokenType {
  ID,
  NUMBER,
  OP_MUL, OP_DIV, OP_PLUS, OP_MINUS, OP_POW,
  BRACKET_OPENED, BRACKET_CLOSED,
  SPACE, // we need spaces in order to save space characters for rewriting
  COMMA,
  EOL,
  UNEXPECTED,
}

export interface FormulaToken {
  type: FormulaTokenType;
  start: number;
  content: string;
}

export interface FormulaTokenDef {
  successiveRE: RegExp;
  completeRE: RegExp;
}

export const FORMULA_SINGLE_CHARACTER_TOKEN_TYPE = {
  '*': FormulaTokenType.OP_MUL,
  '/': FormulaTokenType.OP_DIV,
  '+': FormulaTokenType.OP_PLUS,
  '-': FormulaTokenType.OP_MINUS,
  '^': FormulaTokenType.OP_POW,
  '(': FormulaTokenType.BRACKET_OPENED,
  ')': FormulaTokenType.BRACKET_CLOSED,
  ',': FormulaTokenType.COMMA,
};

export const KEYWORD_TOKEN_TYPE = {};

export const NUMBER_TOKEN_DEF: FormulaTokenDef = {
  successiveRE: /^[0-9]*(\.[0-9]*)?$/,
  completeRE: /^([0-9][0-9]*(\.[0-9]*)?)|(\.[0-9][0-9]*)$/,
};

export const NAMED_TOKEN_DEF: FormulaTokenDef = {
  successiveRE: /^[a-zA-Z_][a-zA-Z0-9_]*$/,
  completeRE: /^[a-zA-Z_][a-zA-Z0-9_]*$/,
};

export function createToken(type: FormulaTokenType, start: number, content: string): FormulaToken {
  return { type, start, content };
}
